<template>
  <v-layout>
    <v-container>
      <v-row>
        <v-col cols="6" sm="6" md="6" justify-center>
          <h1>Reset Password</h1>
        </v-col>
      </v-row>
      <v-form ref="resetPasswordForm" autocomplete="off">
        <v-row>
          <v-col cols="12" sm="12" md="12">
            <v-text-field
              ref="password"
              v-model="newPassword"
              :type="showChangeNewPasswordField ? 'text' : 'password'"
              :rules="[rules.password]"
              :append-icon="
                showChangeNewPasswordField ? 'mdi-eye' : 'mdi-eye-off'
              "
              label="New Password"
              placeholder="New Password"
              @click:append="
                showChangeNewPasswordField = !showChangeNewPasswordField
              "
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="12">
            <v-text-field
              ref="confirmNewPassword"
              v-model="confirmNewPassword"
              :type="showChangeConfirmNewPasswordField ? 'text' : 'password'"
              :rules="[rules.password, passwordConfirmationRule]"
              :append-icon="
                showChangeConfirmNewPasswordField ? 'mdi-eye' : 'mdi-eye-off'
              "
              label="Confirm New Password"
              placeholder=" Confirm New Password"
              @click:append="
                showChangeConfirmNewPasswordField = !showChangeConfirmNewPasswordField
              "
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="submit()">update</v-btn>
        </v-row>
      </v-form>
    </v-container>
    <div class="text-center">
      <v-snackbar
        v-model="snackbar.show"
        :timeout="timeout"
        :color="snackbar.color"
        :top="y === 'top'"
      >
        {{ snackbar.message }}
      </v-snackbar>
    </div>
  </v-layout>
</template>

<script>
import axios from "axios";

/* eslint-disable no-debugger */
export default {
  data: () => ({
    newPassword: null,
    confirmNewPassword: null,
    showChangeNewPasswordField: false,
    showChangeConfirmNewPasswordField: false,
    snackbar: {
      show: false,
      message: null,
      color: null,
    },
    timeout: 4000,
    y: "top",
    email: "",

    rules: {
      password: (value) => {
        const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\\$%\\^&\\*])(?=.{8,})/;
        return (
          pattern.test(value) ||
          "Min. 8 characters with at least one capital letter, a number and a special character."
        );
      },
      pinValidation: (value) => {
        return !!value || "This field is required";
      },
      characterCountValidation: (v) => {
        return v.length == 4 || "Must contain 4 digits";
      },
      onlyNumbersValidation: (value) => {
        const pattern = /^(^[0-9]*$)/;
        return pattern.test(value) || "Only numbers";
      },
    },
    requiredField: [
      (v) => !!v || "This field is required",
      (v) => v.length >= 3 || "Minimum length is 3 characters",
    ],
    token: "",
  }),
  created() {},
  methods: {
    keyupSubmit(e) {
      if (e.keyCode === 13) {
        this.submit();
      }
    },
    submit() {
      //OID10001
      if (this.$refs.resetPasswordForm.validate()) {
        this.$http
          .post(this.$store.getters.getBaseUrl + "resetMyPassword", {
            email: this.email,
            token: this.token,
            newPassword: this.newPassword,
            confirmNewPassword: this.confirmNewPassword,
          })
          .then(() => {
            this.snackbar = {
              message: "Password has been reset. Redirecting To Login",
              color: "success",
              show: true,
            };
            setTimeout(() => {
              this.$router.push("/login");
            }, 3000);
          })
          .catch(function () {
            this.snackbar = {
              message: "Unable To Reset Password",
              color: "error",
              show: true,
            };
          });
      }
    },
    resetFields() {
      this.$refs.form.reset();
    },
  },
  mounted() {
    this.$store.commit("setMenuOptions", []);
    this.token = this.$route.query.token;
    this.email = this.$route.query.email;

    axios
      .get(this.$store.getters.getBaseUrl + "userToken", {
        params: {
          token: this.token,
          email: this.email,
          tokenType: "ForgotPassword",
        },
      })
      .then((result) => {
        console.log(result);
      })
      .catch(function (error) {
        if (error.response.status == "404") {
          alert("Token Not Found Or Expired");
        }
        window.location.href = "/#/login";
      });
  },
  computed: {
    passwordConfirmationRule() {
      return () =>
        this.newPassword === this.confirmNewPassword ||
        "New password must match";
    },
  },
};
</script>

